import React, { useEffect, useState } from "react";
import { Addresses } from "utils/Addresses";
import InputLabel from "../InputLabel/InputLabel";
import "./TextArea.scss";

interface Props {
  lable: string;
  value: number | string;
  className: string;
  error: string | null;
  autoFocus: boolean;
  regex: RegExp | "";
  required: boolean;
  maxlength?: number;
  name: string;
  onChangeValue: (entry: string) => void;
  placeholder?: string;
  disabled?: boolean;
  marginTop?: string;
  removeLable: boolean;
  errorBottom?: string;
  direction?: "ltr" | "rtl";
  autoComplete?: string;
  svgIcon?: string;
  errorClass?: string;
}

const TextArea: React.FC<Props> = ({
  lable,
  value,
  className,
  error,
  autoFocus,
  regex,
  required,
  maxlength = 1000,
  name,
  onChangeValue,
  placeholder,
  disabled,
  marginTop,
  removeLable,
  errorBottom,
  direction,
  autoComplete,
  svgIcon,
  errorClass,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [inputType, setInputType] = useState<string | undefined>("");

  const handleChange = (e: any) => {
    if (e.target.value.match(regex) != null) {
      setInputValue(e.target.value);
      onChangeValue(e.target.value);
    }
  };

  const toggleshowPassword = () => {
    if (inputType === "password") {
      setInputType("text");
    } else {
      setInputType("password");
    }
  };

  return (
    <>
      {removeLable ? null : (
        <InputLabel forId={name + "_input"} lable={lable} required={required} />
      )}
      <div
        style={{
          width: "100%",
          position: "relative",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <textarea 
          style={{
            marginTop: marginTop,
          }}
          id={name + "_input"}
          className={className}
          value={inputValue}
          onChange={(e:any)=>handleChange(e)}
          autoFocus={autoFocus}
          maxLength={maxlength}
          required={required}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autoComplete}
          onFocus={(e) => e.target.select()}
        />
        {svgIcon && (
          <div
            style={{
              position: "absolute",
              right: "0",
              bottom: "0",
              width: "50px",
              height: "50px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <img src={svgIcon} alt="icons-picture" />{" "}
          </div>
        )}
      </div>
      {error ? (
        <span
          style={{ bottom: errorBottom }}
          className={errorClass !== undefined ? errorClass : "error-message"}
        >
          {error}
        </span>
      ) : null}
    </>
  );
};

export default TextArea;
